import React from "react";
import "./SolutionDetailsHero.css";
import { resolveMediaUrl } from "../../../../utils/media";
import extLogo from "../../../../assets/images/allsolutions/ext.svg";
import intLogo from "../../../../assets/images/allsolutions/int.svg";
import ceilLogo from "../../../../assets/images/allsolutions/ceil.svg";

const SolutionDetailsHero = ({ solution }) => {
  if (!solution) return null;

  const solutionKey = String(solution.slug || solution.solutionKey || solution.title || "").toLowerCase();
  const fixedLogoBySolution =
    solutionKey.includes("exterior")
      ? extLogo
      : solutionKey.includes("interior")
        ? intLogo
        : solutionKey.includes("ceiling")
          ? ceilLogo
          : "";
  const solutionLogo = fixedLogoBySolution || resolveMediaUrl(solution.cardIcon) || solution.cardIcon || "";

  return (
    <section className="solutionHero">
      <div className="solutionHero-container">
        <div className="solutionHero-left">
          <span className="solutionHero-tag">{solution.heroTag}</span>

          <h1 className="solutionHero-title">
            IRQGYP – <br />
            {solution.title}
          </h1>

          <p className="solutionHero-desc">{solution.heroDescription}</p>

          <div className="solutionHero-link">
            {solution.specificationsLabel || "View specifications"}
            <span className="arrow">↓</span>
          </div>
        </div>

        {solutionLogo ? (
          <div className="solutionHero-right">
            <img src={solutionLogo} alt={`${solution.title || "Solution"} logo`} draggable={false} />
          </div>
        ) : null}
      </div>
    </section>
  );
};

export default SolutionDetailsHero;
